import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { Divider, Tooltip, Typography } from "@mui/material";
import Filters from "../Components/Filters";
import ScreenerTable from "../Components/ScreenerTable";
import { SCREENER_FILTERS } from "../Service/screener_filters";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          {/* <Typography>{children}</Typography> */}
          {children}
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const Screener = () => {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <div>
        <Box sx={{ width: "100%" }}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="basic tabs example"
              centered
            >
              <Tab label="Descriptive" {...a11yProps(0)} />
              {/* <Tab label="Fundamental" {...a11yProps(1)} /> */}
            </Tabs>
          </Box>
          <CustomTabPanel value={value} index={0}>
            <Filters
                data={SCREENER_FILTERS['descriptive']}
            />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={1}>
          <Filters
                data={SCREENER_FILTERS['fundamental']}
            />
          </CustomTabPanel>
        </Box>
      </div>

      <Divider />
      <ScreenerTable />
    </div>
  );
};

export default Screener;
